import Form from "../components/Form";
import Head from "../components/Head";
import Login from "../components/Login";

function Calucator() {
  
    return (
      <>
        <Head />
        <Form />
      </>
    );
  }
  
  export default Calucator;